import React from 'react'

import Slider from '../../../components/slider'
import { DocumentCard } from '../../../components/content'
import type { Document } from '../../../../api/documents/types'
import Loading from '../../../components/layout/Loading'
import NoResults from '../../../components/layout/NoResults'

interface Props {
  queryFn: () => { data: Document[] | null | undefined, isLoading: boolean, error: Error | null }
}
const DocumentsCarousel: React.FC<Props> = ({ queryFn }) => {
  const { data, isLoading, error } = queryFn()

  if(isLoading) return <Loading />
  if(error) return <div>{error.message}</div>
  if(!data || data?.length === 0) return <NoResults />

  return (
    <Slider slidesXs={2.1}>
      {data.map((doc: Document) => (
        <DocumentCard
          id={doc.id}
          key={doc.title}
          title={doc.title}
          authors={doc.authors}
          type={doc.type}
          difficulty={doc.difficultyLevel.name}
          category={doc.mainCategory.name}
          bookmarked={doc?.userActivity?.saved}
        />
      ))}
    </Slider>
  )
}

export default DocumentsCarousel
